import { ComponentProps, PropsWithChildren } from "react";

import { Avatar as BaseAvatar } from "@base-ui-components/react/avatar";
import {
  avatarClasses,
  avatarImageClasses,
  type AvatarVariants,
} from "./Avatar.style";

type AvatarProps = AvatarVariants &
  ComponentProps<"img"> & {
    alt?: string | undefined;
    src?: string | undefined;
    className?: string;
  };

const getInitials = (alt: string) => {
  const altArr = alt?.toUpperCase()?.split(" ");
  let initials = altArr?.[0]?.[0];
  if (altArr?.[1]?.[0]) {
    initials += altArr[1][0];
  }
  return initials;
};
function Avatar(props: PropsWithChildren<AvatarProps>) {
  const {
    children,
    size = "medium",
    src,
    alt,
    variant = "circle",
    className,
  } = props;

  return (
    <BaseAvatar.Root
      className={avatarClasses({
        className: className,
        variant: variant,
        size: size,
      })}
    >
      {src && (
        <>
          <BaseAvatar.Image
            src={src}
            width="48"
            height="48"
            alt={alt}
            className={avatarImageClasses({})}
          />
          <BaseAvatar.Fallback className="flex size-full items-center justify-center text-base">
            {alt ? getInitials(alt) : children}
          </BaseAvatar.Fallback>
        </>
      )}

      {children}
    </BaseAvatar.Root>
  );
}

export default Avatar;
